﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/securefiledelivery`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetAgentRequests' },
  { name: 'VerifyFilesExistToDownload' },
  { name: 'GetDocumentContent' },
  { name: 'UpdateRequest' },
]);

const GetAgentRequests = (body) => api.endpoints.GetAgentRequests.post(body);
const VerifyFilesExistToDownload = (body) => api.endpoints.VerifyFilesExistToDownload.post(body);
const GetDocumentContent = (queries) =>
  api.endpoints.GetDocumentContent.getMultipleQueryString(queries);
const UpdateRequest = (body) => api.endpoints.UpdateRequest.patch(body);

export { GetAgentRequests, VerifyFilesExistToDownload, GetDocumentContent, UpdateRequest };
